import { TemplateLoadingScreen } from "@/components/templates/TemplateLoadingScreen";
import type { RedirectLoadingReason } from "@/lib/redirectLoadingSurfaces";
import { useEffect } from "react";
import { useNavigate, type To } from "react-router-dom";

type RedirectWithLoadingGateProps = {
  to: To;
  replace?: boolean;
  reason: RedirectLoadingReason;
  message?: string;
};

/**
 * Muestra el splash de marca mientras navega (replace) al destino.
 * Evita flash en blanco o un frame de Mux antes del redirect.
 */
export function RedirectWithLoadingGate({
  to,
  replace = true,
  reason,
  message,
}: RedirectWithLoadingGateProps) {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const ph = (window as { posthog?: { capture: (e: string, p: object) => void } })
        .posthog;
      ph?.capture("redirect_loading_gate", {
        reason,
        to: typeof to === "string" ? to : JSON.stringify(to),
      });
    }
    navigate(to, { replace });
    // Solo al montar: este componente existe únicamente para un redirect puntual.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TemplateLoadingScreen
      message={message}
      data-testid="redirect-loading-gate"
    />
  );
}